import React from 'react';
import { Button, Space } from 'antd';
// Types
import { GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items } from 'api/campaignV2/types/GetCampaignOffers';
// Styles
import styles from './ReviewButtons.module.scss';

type ReviewButtonsProps = {
  isApproved: boolean;
  isRejected: boolean;
  handleApprove: () => void;
  handleReject: () => void;
  alreadyReviewed: boolean;
  onRejectClick?: (
    item: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items
  ) => void;
  item: GetCampaignOffers_getCampaignOffers_entities_deliverablesV2_items;
};

const ReviewButtons: React.FC<ReviewButtonsProps> = ({
  isApproved,
  isRejected,
  handleApprove,
  handleReject,
  alreadyReviewed,
  onRejectClick,
  item,
}) => {
  const handleRejectClick = () => {
    if (onRejectClick) {
      onRejectClick(item);
    } else {
      handleReject();
    }
  };

  return (
    <Space className={styles.reviewButtons}>
      <Button
        type={isApproved ? 'primary' : 'default'}
        onClick={handleApprove}
        disabled={alreadyReviewed}
        className={isApproved ? styles.approvedButton : styles.approveButton}
      >
        {isApproved ? 'Approved' : 'Approve'}
      </Button>
      <Button
        type={isRejected ? 'primary' : 'default'}
        danger={isRejected}
        onClick={handleRejectClick}
        disabled={alreadyReviewed}
        className={isRejected ? styles.rejectedButton : styles.rejectButton}
      >
        {isRejected ? 'Rejected' : 'Reject'}
      </Button>
    </Space>
  );
};

export default ReviewButtons;
